(() => {
// Init i18n (defaults + translate())
const $661ba832864544bd$var$DEFAULT_STRINGS = {
    "cart.error.default": "Failed to add items to the cart. Please try again.",
    "cart.error.invalid_selection": "Please select one option for each product in the bundle.",
    "cart.error.invalid_variant": "One of the selected variants is invalid. Please check your selections.",
    "cart.error.invalid_quantity": "Invalid quantity. Please enter a valid number.",
    "cart.error.element_not_found": "Required element not found: {selector}",
    "cart.error.invalid_request": "Invalid request. Please check your selections.",
    "cart.error.not_found": "Selected item not found. It may no longer be available.",
    "cart.error.unprocessable": "There was an issue with the items selected (e.g., unavailable or invalid). Please review your selection.",
    "cart.error.server_error": "Server error. Please try again later.",
    "cart.error.unexpected": "An unexpected error occurred. Please try again."
};
const $661ba832864544bd$var$themeVariables = window.themeVariables = window.themeVariables ?? {};
$661ba832864544bd$var$themeVariables.strings = {
    ...$661ba832864544bd$var$DEFAULT_STRINGS,
    ...$661ba832864544bd$var$themeVariables.strings ?? {}
};
const $661ba832864544bd$export$d73ee8ef04f5226a = (key, fallback)=>{
    const message = window.themeVariables?.strings?.[key];
    return typeof message === "string" && message.trim() ? message : fallback;
};
const $661ba832864544bd$var$get = (key)=>{
    const message = window.themeVariables?.strings?.[key];
    return typeof message === "string" && message.trim() ? message : $661ba832864544bd$var$DEFAULT_STRINGS[key];
};
const $661ba832864544bd$export$9e0efcb140234d2 = {
    DEFAULT: $661ba832864544bd$var$get("cart.error.default"),
    INVALID_SELECTION: $661ba832864544bd$var$get("cart.error.invalid_selection"),
    INVALID_VARIANT: $661ba832864544bd$var$get("cart.error.invalid_variant"),
    INVALID_QUANTITY: $661ba832864544bd$var$get("cart.error.invalid_quantity"),
    INVALID_REQUEST: $661ba832864544bd$var$get("cart.error.invalid_request"),
    NOT_FOUND: $661ba832864544bd$var$get("cart.error.not_found"),
    UNPROCESSABLE: $661ba832864544bd$var$get("cart.error.unprocessable"),
    SERVER_ERROR: $661ba832864544bd$var$get("cart.error.server_error"),
    UNEXPECTED: $661ba832864544bd$var$get("cart.error.unexpected")
};
const $661ba832864544bd$export$230496901dea34a2 = (selector)=>$661ba832864544bd$var$get("cart.error.element_not_found").replace("{selector}", selector);


function $d4f48f8a853fbb3a$var$sectionIdOf(el) {
    if (!el) return null;
    const withData = el.closest("[data-section-id]");
    if (withData instanceof HTMLElement && withData.dataset.sectionId) return withData.dataset.sectionId;
    const withId = el.closest('[id^="shopify-section-"]');
    if (withId && withId.id.startsWith("shopify-section-")) return withId.id.slice(16);
    return null;
}
function $d4f48f8a853fbb3a$var$collectSectionRoots(selectors) {
    const sectionRoots = new Map();
    for (const selector of selectors)document.querySelectorAll(selector).forEach((node)=>{
        const sectionId = $d4f48f8a853fbb3a$var$sectionIdOf(node);
        if (!sectionId) return;
        const sectionRoot = document.querySelector(`[data-section-id="${sectionId}"]`) || document.getElementById(`shopify-section-${sectionId}`);
        if (sectionRoot) sectionRoots.set(sectionId, sectionRoot);
    });
    return sectionRoots;
}
function $d4f48f8a853fbb3a$var$replaceFromDoc(targetRoot, sourceDoc, selectors) {
    const updatedSelectors = new Set();
    for (const selector of selectors){
        const currentNodes = targetRoot.querySelectorAll(selector);
        if (!currentNodes.length) continue;
        const sourceNodes = sourceDoc.querySelectorAll(selector);
        const count = Math.min(currentNodes.length, sourceNodes.length);
        let changed = false;
        for(let i = 0; i < count; i++){
            const freshNode = sourceNodes[i];
            if (!(freshNode instanceof Element)) continue;
            if (currentNodes[i].outerHTML === freshNode.outerHTML) continue;
            currentNodes[i].replaceWith(document.importNode(freshNode, true));
            changed = true;
        }
        if (changed) updatedSelectors.add(selector);
    }
    updatedSelectors.forEach((selector)=>{
        document.dispatchEvent(new CustomEvent("shopify:section:load", {
            detail: {
                selector: selector
            }
        }));
    });
}
async function $d4f48f8a853fbb3a$export$c5303087167e431c(selectors, sectionId) {
    if (!selectors.length) return;
    const hasAnyTarget = selectors.some((selector)=>!!document.querySelector(selector));
    if (!hasAnyTarget) return;
    const sectionRoots = $d4f48f8a853fbb3a$var$collectSectionRoots(selectors);
    try {
        if (sectionId || sectionRoots.size > 0) {
            const sectionIds = sectionId ? [
                sectionId
            ] : Array.from(sectionRoots.keys());
            const response = await fetch(`?sections=${sectionIds.join(",")}`);
            if (!response.ok) return;
            const sectionsPayload = await response.json();
            const sectionDocuments = new Map();
            if (sectionsPayload && typeof sectionsPayload === "object") {
                for (const [sectionKey, sectionHtml] of Object.entries(sectionsPayload))if (typeof sectionHtml === "string") sectionDocuments.set(sectionKey, new DOMParser().parseFromString(sectionHtml, "text/html"));
            }
            for (const [secId, sectionRoot] of sectionRoots.entries()){
                const sectionDoc = sectionDocuments.get(secId);
                if (sectionDoc) $d4f48f8a853fbb3a$var$replaceFromDoc(sectionRoot, sectionDoc, selectors);
            }
            return;
        }
        const responseFull = await fetch(location.href);
        if (!responseFull.ok) return;
        const html = await responseFull.text();
        const fullDoc = new DOMParser().parseFromString(html, "text/html");
        $d4f48f8a853fbb3a$var$replaceFromDoc(document, fullDoc, selectors);
    } catch (err) {
        console.warn("Update Elements failed:", err);
    }
}


const $e1fa18a0ea3067b5$export$61fc7d43ac8f84b0 = (fn, delay)=>{
    let timer = null;
    const debounced = (...args)=>{
        if (timer) clearTimeout(timer);
        timer = setTimeout(()=>fn(...args), delay);
    };
    return debounced;
};



const $19bf1ee578786977$export$a17b3c2052469c69 = (amount)=>{
    const settings = window.themeVariables?.settings;
    const withCode = settings?.currencyCodeEnabled === true;
    const template = withCode ? settings?.moneyWithCurrencyFormat || "${{amount}} AUD" : settings?.moneyFormat || "${{amount}}";
    const cents = Math.round(amount * 100);
    const match = template.match(/\{\{\s*([^\s}]+)\s*\}\}/);
    const token = match ? match[1] : "amount";
    const numberWithSeparators = (valueCents, decimals, thousands, decimal)=>{
        if (decimals === 0) {
            const major = Math.round(valueCents / 100);
            return major.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        }
        const major = Math.floor(valueCents / 100);
        const minor = Math.abs(valueCents % 100).toString().padStart(2, "0");
        const intPart = major.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return `${intPart}${decimal}${minor}`;
    };
    const formatted = (()=>{
        switch(token){
            case "amount_no_decimals":
                return numberWithSeparators(cents, 0, ",", ".");
            case "amount_with_comma_separator":
                return numberWithSeparators(cents, 2, ".", ",");
            case "amount_no_decimals_with_comma_separator":
                return numberWithSeparators(cents, 0, ".", ",");
            case "amount_with_space_separator":
                return numberWithSeparators(cents, 2, " ", ",");
            case "amount_no_decimals_with_space_separator":
                return numberWithSeparators(cents, 0, " ", ",");
            case "amount_with_apostrophe_separator":
                return numberWithSeparators(cents, 2, "'", ".");
            case "amount":
            default:
                return numberWithSeparators(cents, 2, ",", ".");
        }
    })();
    return template.replace(/\{\{\s*[^\s}]+\s*\}\}/, formatted);
};
const $19bf1ee578786977$export$598e5ba180969af0 = (text)=>{
    const cleaned = text?.trim().replace(/[^\d.,-]/g, "") || "";
    if (!cleaned) return null;
    const normalized = cleaned.includes(",") && cleaned.includes(".") ? cleaned.replace(/,/g, "") : cleaned.replace(/,(?=\d{2}(?!\d))/g, ".");
    const num = Number.parseFloat(normalized);
    if (!Number.isFinite(num)) return null;
    return Math.max(0, Math.round(num * 100));
};
const $19bf1ee578786977$export$7ee1718a1d856601 = (cents)=>{
    const value = Number.isFinite(cents) ? Math.max(0, cents) : 0;
    return (value / 100).toFixed(2);
};


const $91245019425ebde7$var$fixedBasePriceCache = new WeakMap();
function $91245019425ebde7$var$getFixedPriceContainer() {
    const info = document.querySelector($91245019425ebde7$var$selectors.productInfo);
    return info?.querySelector(".product-info__price") || info || null;
}
function $91245019425ebde7$var$getFixedBasePrices() {
    const container = $91245019425ebde7$var$getFixedPriceContainer();
    if (!container) return null;
    const cached = $91245019425ebde7$var$fixedBasePriceCache.get(container);
    if (cached) return cached;
    const sale = $91245019425ebde7$var$centsFromText($91245019425ebde7$var$elements.priceSaleEl);
    if (sale === null) return null;
    const compare = $91245019425ebde7$var$centsFromText($91245019425ebde7$var$elements.priceRegularEl);
    const base = {
        sale: sale,
        compare: compare
    };
    $91245019425ebde7$var$fixedBasePriceCache.set(container, base);
    return base;
}
const $91245019425ebde7$var$ERROR_ICON_SVG = `
<svg role="presentation" focusable="false" width="18" height="18" class="offset-icon icon icon-error" style="--icon-height: 18px" viewBox="0 0 18 18">
<path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
<path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
</svg>
`;
const $91245019425ebde7$var$ERROR_MESSAGES = (0, $661ba832864544bd$export$9e0efcb140234d2);
const $91245019425ebde7$var$selectors = {
    productInfo: "[data-product-info]",
    quantitySelector: "[data-quantity-selector]",
    errorMessageContainer: "[data-bundle-error-message]",
    productCount: "[data-product-count]",
    priceSale: "[data-price-sale]",
    priceBadge: "[data-price-badge]",
    priceRegular: "[data-price-regular]",
    productData: "[data-product-data]",
    dataCartItems: "[data-cart-items]",
    bundleGroup: "[data-bundle-group]",
    dataVariantRadioInput: "[data-variant-radio-input]",
    addBundleButton: "[data-add-bundle-button]"
};
let $91245019425ebde7$var$elements = {
    productInfo: null,
    quantityInput: null,
    errorMessageContainer: null,
    productCountEl: null,
    cartItemsEl: null,
    priceSaleEl: null,
    priceBadgeEl: null,
    priceRegularEl: null,
    addBundleButton: null,
    bundleGroups: null,
    bundleInputs: null
};
function $91245019425ebde7$var$ensureAddButtonListener() {
    const btn = $91245019425ebde7$var$elements.addBundleButton;
    if (!btn) return;
    btn.removeEventListener("click", $91245019425ebde7$var$handleAddToCart);
    btn.addEventListener("click", $91245019425ebde7$var$handleAddToCart);
}
function $91245019425ebde7$var$cacheElements() {
    const productInfo = document.querySelector($91245019425ebde7$var$selectors.productInfo);
    $91245019425ebde7$var$elements = {
        productInfo: productInfo,
        quantityInput: productInfo?.querySelector($91245019425ebde7$var$selectors.quantitySelector) ?? document.querySelector($91245019425ebde7$var$selectors.quantitySelector),
        errorMessageContainer: document.querySelector($91245019425ebde7$var$selectors.errorMessageContainer),
        productCountEl: document.querySelector($91245019425ebde7$var$selectors.productCount),
        cartItemsEl: document.querySelector($91245019425ebde7$var$selectors.dataCartItems),
        priceSaleEl: productInfo?.querySelector($91245019425ebde7$var$selectors.priceSale) || productInfo?.querySelector("sale-price") || productInfo?.querySelector(".text-on-sale") || null,
        priceBadgeEl: productInfo?.querySelector($91245019425ebde7$var$selectors.priceBadge) || productInfo?.querySelector("on-sale-badge, .badge--on-sale") || null,
        priceRegularEl: productInfo?.querySelector($91245019425ebde7$var$selectors.priceRegular) || productInfo?.querySelector("compare-at-price, .line-through") || null,
        addBundleButton: document.querySelector($91245019425ebde7$var$selectors.addBundleButton),
        bundleGroups: document.querySelectorAll($91245019425ebde7$var$selectors.bundleGroup),
        bundleInputs: document.querySelectorAll($91245019425ebde7$var$selectors.dataVariantRadioInput)
    };
}
// currency code is resolved by Liquid money formats; no need to store here
function $91245019425ebde7$var$centsFromText(el) {
    return (0, $19bf1ee578786977$export$598e5ba180969af0)(el?.textContent || "");
}
function $91245019425ebde7$var$centsFromDataset(el, key) {
    if (!el) return null;
    const raw = el.dataset[key];
    if (!raw) return null;
    const parsed = Number.parseInt(raw, 10);
    if (Number.isNaN(parsed)) return null;
    return parsed;
}
function $91245019425ebde7$var$readCents(el, datasetKey) {
    return $91245019425ebde7$var$centsFromDataset(el, datasetKey) ?? $91245019425ebde7$var$centsFromText(el);
}
function $91245019425ebde7$var$parseNonNegativeInt(value) {
    if (typeof value !== "string" || value.trim() === "") return null;
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
}
function $91245019425ebde7$var$getProductCount() {
    return parseInt($91245019425ebde7$var$elements.productCountEl?.dataset.productCount ?? "0", 10) || 0;
}
function $91245019425ebde7$var$getCartItemCount() {
    return parseInt($91245019425ebde7$var$elements.cartItemsEl?.dataset.cartItems ?? "0", 10) || 0;
}
function $91245019425ebde7$var$getProductQuantity() {
    return parseInt($91245019425ebde7$var$elements.quantityInput?.value ?? "0", 10) || 0;
}
function $91245019425ebde7$var$isFixBundleContext() {
    return !!document.querySelector(".hidden-variant-picker");
}
function $91245019425ebde7$var$displayErrorMessage(message) {
    const container = $91245019425ebde7$var$elements.errorMessageContainer;
    if (!container) {
        console.warn("Error message container not found. Using fallback banner.");
        const toast = document.createElement("div");
        toast.setAttribute("role", "status");
        toast.setAttribute("aria-live", "polite");
        toast.className = "toast toast--error";
        toast.textContent = message;
        document.body.appendChild(toast);
        setTimeout(()=>toast.remove(), 3500);
        return;
    }
    container.classList.remove("is-hidden", "is-hiding");
    container.classList.add("is-visible");
    container.innerHTML = `${$91245019425ebde7$var$ERROR_ICON_SVG} <span>${message}</span>`;
    setTimeout(()=>container.classList.add("is-hiding"), 3500);
    setTimeout(()=>{
        container.classList.remove("is-visible", "is-hiding");
        container.classList.add("is-hidden");
    }, 4000);
}
function $91245019425ebde7$var$getSelectedBundleVariants(setQuantity) {
    const selectedVariants = [];
    if (!$91245019425ebde7$var$elements.bundleGroups || $91245019425ebde7$var$elements.bundleGroups.length === 0) {
        console.warn("No bundle groups found to collect items from.");
        return null;
    }
    for (const bundleGroup of $91245019425ebde7$var$elements.bundleGroups){
        const selectedVariant = bundleGroup.querySelector('input[type="radio"]:checked');
        if (!selectedVariant) {
            $91245019425ebde7$var$displayErrorMessage($91245019425ebde7$var$ERROR_MESSAGES.INVALID_SELECTION);
            return null;
        }
        const variantId = parseInt(selectedVariant.value, 10);
        if (isNaN(variantId)) {
            $91245019425ebde7$var$displayErrorMessage($91245019425ebde7$var$ERROR_MESSAGES.INVALID_VARIANT);
            return null;
        }
        const qtyEachRaw = selectedVariant.dataset.variantQty;
        const qtyEach = qtyEachRaw ? parseInt(qtyEachRaw, 10) || 1 : 1;
        const totalQty = Math.max(1, setQuantity) * Math.max(1, qtyEach);
        selectedVariants.push({
            id: variantId,
            quantity: totalQty
        });
    }
    return selectedVariants;
}
async function $91245019425ebde7$var$getErrorMessageFromResponse(response) {
    try {
        const errorData = await response.json();
        return errorData?.description || errorData?.message || $91245019425ebde7$var$ERROR_MESSAGES.DEFAULT;
    } catch  {
        switch(response.status){
            case 400:
                return (0, $661ba832864544bd$export$9e0efcb140234d2).INVALID_REQUEST;
            case 404:
                return (0, $661ba832864544bd$export$9e0efcb140234d2).NOT_FOUND;
            case 422:
                return (0, $661ba832864544bd$export$9e0efcb140234d2).UNPROCESSABLE;
            case 500:
                return (0, $661ba832864544bd$export$9e0efcb140234d2).SERVER_ERROR;
            default:
                return (0, $661ba832864544bd$export$9e0efcb140234d2).UNEXPECTED;
        }
    }
}
let $91245019425ebde7$var$cachedDiscountRules = null;
let $91245019425ebde7$var$lastDiscountRulesSource = null;
function $91245019425ebde7$var$hasType(source, key, expectedType) {
    const propValue = Reflect.get(source, key);
    return typeof propValue === expectedType;
}
function $91245019425ebde7$var$isUndefined(source, key) {
    const propValue = Reflect.get(source, key);
    return typeof propValue === "undefined";
}
function $91245019425ebde7$var$isDiscountRule(value) {
    if (!value || typeof value !== "object") return false;
    return $91245019425ebde7$var$hasType(value, "percentage", "number") && $91245019425ebde7$var$hasType(value, "minimum_quantity_of_items", "number") && ($91245019425ebde7$var$hasType(value, "is_active", "boolean") || $91245019425ebde7$var$isUndefined(value, "is_active"));
}
function $91245019425ebde7$var$invalidateDiscountRulesCache() {
    $91245019425ebde7$var$cachedDiscountRules = null;
    $91245019425ebde7$var$lastDiscountRulesSource = null;
}
function $91245019425ebde7$var$getDiscountRules() {
    try {
        const json = $91245019425ebde7$var$elements.productInfo?.dataset.discountRules ?? "[]";
        if (json !== $91245019425ebde7$var$lastDiscountRulesSource || !$91245019425ebde7$var$cachedDiscountRules) {
            const parsedUnknown = JSON.parse(json);
            const arr = Array.isArray(parsedUnknown) ? parsedUnknown : [];
            const rules = arr.filter($91245019425ebde7$var$isDiscountRule);
            $91245019425ebde7$var$cachedDiscountRules = rules.filter((rule)=>rule.minimum_quantity_of_items >= 0 && rule.percentage >= 0 && rule.is_active !== false);
            $91245019425ebde7$var$lastDiscountRulesSource = json;
        }
        return $91245019425ebde7$var$cachedDiscountRules ?? [];
    } catch (err) {
        console.warn("Failed to parse or resolve discount rules; using empty set.", err);
        return [];
    }
}
function $91245019425ebde7$var$getBestDiscount(totalQuantity, rules) {
    return rules.reduce((maxDiscount, rule)=>{
        if (totalQuantity >= rule.minimum_quantity_of_items) return Math.max(maxDiscount, rule.percentage);
        return maxDiscount;
    }, 0);
}
function $91245019425ebde7$var$buildPriceState(regularTotalCents, saleTotalCents, percentageOverride) {
    const regularCents = Math.max(0, regularTotalCents);
    const saleCents = Math.max(0, Math.min(regularCents, saleTotalCents));
    const saveCents = Math.max(0, regularCents - saleCents);
    const computedPercentage = regularCents > 0 ? Math.round(saveCents / regularCents * 100) : 0;
    const discountPercentage = typeof percentageOverride === "number" ? percentageOverride : computedPercentage;
    return {
        priceRegular: regularCents / 100,
        priceSale: saleCents / 100,
        priceSave: saveCents / 100,
        discountPercentage: discountPercentage
    };
}
function $91245019425ebde7$var$getPriceState() {
    if ($91245019425ebde7$var$isFixBundleContext()) {
        const quantity = $91245019425ebde7$var$getProductQuantity();
        if (quantity < 1) return null;
        const base = $91245019425ebde7$var$getFixedBasePrices();
        if (!base) return null;
        const unitSaleCents = base.sale;
        const unitCompareCents = base.compare ?? unitSaleCents;
        const qty = Math.max(quantity, 1);
        return $91245019425ebde7$var$buildPriceState(unitCompareCents * qty, unitSaleCents * qty);
    }
    const quantity = $91245019425ebde7$var$getProductQuantity();
    if (quantity < 1) return null;
    const productCount = $91245019425ebde7$var$getProductCount();
    const cartCount = $91245019425ebde7$var$getCartItemCount();
    const rules = $91245019425ebde7$var$getDiscountRules();
    const totalQuantity = productCount * quantity + cartCount;
    const discountPercentage = $91245019425ebde7$var$getBestDiscount(totalQuantity, rules);
    const bundleInputs = $91245019425ebde7$var$elements.bundleInputs;
    let state = null;
    if (!bundleInputs || bundleInputs.length === 0) state = $91245019425ebde7$var$getSimpleProductPriceState(quantity, discountPercentage);
    else state = $91245019425ebde7$var$getBundleProductPriceState(bundleInputs, quantity, discountPercentage);
    if (!state) return null;
    return $91245019425ebde7$var$withPlaceholderTotals(state, quantity, discountPercentage);
}
function $91245019425ebde7$var$getSimpleProductPriceState(quantity, discountPercentage) {
    const regularCents = $91245019425ebde7$var$readCents($91245019425ebde7$var$elements.priceRegularEl, "priceRegular");
    if (regularCents === null) return null;
    const saleCents = $91245019425ebde7$var$readCents($91245019425ebde7$var$elements.priceSaleEl, "priceSale");
    const qty = Math.max(quantity, 1);
    const regularTotal = regularCents * qty;
    const discountCents = Math.round(regularTotal * discountPercentage / 100);
    let saleTotal = Math.max(0, regularTotal - discountCents);
    if (saleCents !== null) {
        const manualTotal = saleCents * qty;
        saleTotal = discountPercentage > 0 ? Math.min(saleTotal, manualTotal) : manualTotal;
    }
    return $91245019425ebde7$var$buildPriceState(regularTotal, saleTotal, discountPercentage);
}
function $91245019425ebde7$var$getBundleProductPriceState(inputs, quantity, discountPercentage) {
    let bundleBaseCents = 0;
    let bundleDiscountedCents = 0;
    inputs.forEach((input)=>{
        if (!input.checked) return;
        const variantPriceCents = Number.parseInt(input.dataset.variantPrice ?? "0", 10);
        if (Number.isNaN(variantPriceCents)) return;
        const variantQuantityInSet = input.dataset.variantQty ? Number.parseInt(input.dataset.variantQty, 10) || 1 : 1;
        const variantSubtotalCents = variantPriceCents * variantQuantityInSet;
        bundleBaseCents += variantSubtotalCents;
        const variantDiscountCents = Math.round(variantSubtotalCents * discountPercentage / 100);
        bundleDiscountedCents += variantSubtotalCents - variantDiscountCents;
    });
    if (bundleBaseCents <= 0) return null;
    const qty = Math.max(quantity, 1);
    const regularTotal = bundleBaseCents * qty;
    const saleTotal = bundleDiscountedCents * qty;
    return $91245019425ebde7$var$buildPriceState(regularTotal, saleTotal, discountPercentage);
}
function $91245019425ebde7$var$getPlaceholderContributionCents(discountPercentage) {
    const root = $91245019425ebde7$var$elements.productInfo || document;
    const placeholders = root.querySelectorAll("[data-bundle-group-by-tag]");
    if (placeholders.length === 0) return {
        baseCents: 0,
        saleCents: 0
    };
    let baseCents = 0;
    let saleCents = 0;
    placeholders.forEach((el)=>{
        const price = $91245019425ebde7$var$parseNonNegativeInt(el instanceof HTMLElement ? el.dataset.currentVariantPrice ?? null : null);
        const qtyEach = $91245019425ebde7$var$parseNonNegativeInt(el instanceof HTMLElement ? el.dataset.quantity ?? null : null) || 1;
        if (price === null) return;
        const subtotal = price * Math.max(1, qtyEach);
        baseCents += subtotal;
        const discount = Math.round(subtotal * discountPercentage / 100);
        saleCents += subtotal - discount;
    });
    return {
        baseCents: baseCents,
        saleCents: saleCents
    };
}
function $91245019425ebde7$var$withPlaceholderTotals(state, quantity, discountPercentage) {
    const { baseCents: baseCents, saleCents: saleCents } = $91245019425ebde7$var$getPlaceholderContributionCents(discountPercentage);
    if (baseCents <= 0) return state;
    const qty = Math.max(quantity, 1);
    const regularTotal = Math.round(state.priceRegular * 100) + baseCents * qty;
    const saleTotal = Math.round(state.priceSale * 100) + saleCents * qty;
    return $91245019425ebde7$var$buildPriceState(regularTotal, saleTotal, discountPercentage);
}
function $91245019425ebde7$var$updatePriceUI() {
    const state = $91245019425ebde7$var$getPriceState();
    if (!state) return;
    const { priceSale: priceSale, priceRegular: priceRegular, priceSave: priceSave, discountPercentage: discountPercentage } = state;
    const format = (val)=>(0, $19bf1ee578786977$export$a17b3c2052469c69)(val);
    const saleElement = $91245019425ebde7$var$elements.priceSaleEl;
    const regularElement = $91245019425ebde7$var$elements.priceRegularEl;
    const hasReduction = priceRegular - priceSale > 0.001;
    const showSeparateSale = hasReduction && saleElement !== null && saleElement !== regularElement;
    if (regularElement) {
        regularElement.textContent = format(priceRegular);
        regularElement.setAttribute("aria-label", `${(0, $661ba832864544bd$export$d73ee8ef04f5226a)("product.price.regular", "Regular price")}: ${format(priceRegular)}`);
        regularElement.style.textDecoration = showSeparateSale ? "line-through" : "";
        const shouldHideRegular = !showSeparateSale && !!saleElement && saleElement !== regularElement;
        regularElement.style.display = shouldHideRegular ? "none" : "";
    }
    if (saleElement) {
        const saleClassList = saleElement.classList;
        const ensureTextSize = ()=>{
            if (!saleClassList.contains("text-lg")) saleClassList.add("text-lg");
        };
        if (saleElement === regularElement || !regularElement) {
            const labelKey = hasReduction ? "product.price.current" : "product.price.regular";
            const labelFallback = hasReduction ? "Price" : "Regular price";
            const value = hasReduction ? priceSale : priceRegular;
            saleElement.textContent = format(value);
            saleElement.setAttribute("aria-label", `${(0, $661ba832864544bd$export$d73ee8ef04f5226a)(labelKey, labelFallback)}: ${format(value)}`);
            saleElement.style.textDecoration = "";
            saleElement.style.display = "";
            saleClassList.toggle("text-on-sale", hasReduction);
            ensureTextSize();
        } else {
            saleElement.textContent = format(priceSale);
            saleElement.setAttribute("aria-label", `${(0, $661ba832864544bd$export$d73ee8ef04f5226a)("product.price.current", "Price")}: ${format(priceSale)}`);
            saleElement.style.display = "";
            saleClassList.toggle("text-on-sale", hasReduction);
            ensureTextSize();
        }
    }
    if ($91245019425ebde7$var$elements.priceBadgeEl) {
        if (priceSave > 0) {
            $91245019425ebde7$var$elements.priceBadgeEl.textContent = `${(0, $661ba832864544bd$export$d73ee8ef04f5226a)("product.price.save", "Save")} ${format(priceSave)}`;
            $91245019425ebde7$var$elements.priceBadgeEl.setAttribute("aria-label", `${(0, $661ba832864544bd$export$d73ee8ef04f5226a)("product.price.save", "Save")}: ${format(priceSave)} (${discountPercentage}%)`);
            $91245019425ebde7$var$elements.priceBadgeEl.style.display = "";
        } else $91245019425ebde7$var$elements.priceBadgeEl.style.display = "none";
    }
}
async function $91245019425ebde7$var$postToCart(items, addButton) {
    if (!addButton) return {
        success: false,
        error: $91245019425ebde7$var$ERROR_MESSAGES.DEFAULT
    };
    addButton.setAttribute("aria-busy", "true");
    addButton.disabled = true;
    const originalButtonText = addButton.textContent;
    addButton.textContent = (0, $661ba832864544bd$export$d73ee8ef04f5226a)("cart.adding", "Adding...");
    try {
        if (window.CartJS && typeof window.CartJS.addItems === "function") {
            const cartJsItems = items.map((it)=>({
                    id: String(it.id),
                    quantity: it.quantity
                }));
            await window.CartJS.addItems(cartJsItems);
            return {
                success: true,
                data: {
                    via: "CartJS"
                }
            };
        }
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                items: items
            })
        });
        if (!response.ok) {
            const errorMessage = await $91245019425ebde7$var$getErrorMessageFromResponse(response);
            $91245019425ebde7$var$displayErrorMessage(errorMessage);
            return {
                success: false,
                error: errorMessage
            };
        }
        const responseData = await response.json();
        return {
            success: true,
            data: responseData
        };
    } catch (error) {
        const message = error instanceof Error ? error.message : $91245019425ebde7$var$ERROR_MESSAGES.DEFAULT;
        $91245019425ebde7$var$displayErrorMessage(message);
        return {
            success: false,
            error: message
        };
    } finally{
        addButton.removeAttribute("aria-busy");
        addButton.disabled = false;
        addButton.textContent = originalButtonText;
    }
}
async function $91245019425ebde7$var$handleAddToCart() {
    if (!$91245019425ebde7$var$elements.addBundleButton) return;
    const quantity = $91245019425ebde7$var$getProductQuantity();
    if (quantity < 1) {
        $91245019425ebde7$var$displayErrorMessage($91245019425ebde7$var$ERROR_MESSAGES.INVALID_QUANTITY);
        return;
    }
    const isBundle = $91245019425ebde7$var$elements.bundleGroups && $91245019425ebde7$var$elements.bundleGroups.length > 0;
    let selectedVariants = null;
    if (isBundle) {
        selectedVariants = $91245019425ebde7$var$getSelectedBundleVariants(quantity);
        if (selectedVariants === null) return;
    } else {
        const variantInput = document.querySelector('input[name="id"]:checked, input[name="id"]');
        const variantId = variantInput ? parseInt(variantInput.value, 10) : null;
        if (!variantId || isNaN(variantId)) {
            $91245019425ebde7$var$displayErrorMessage($91245019425ebde7$var$ERROR_MESSAGES.INVALID_VARIANT);
            return;
        }
        selectedVariants = [
            {
                id: variantId,
                quantity: quantity
            }
        ];
    }
    if (!selectedVariants || selectedVariants.length === 0) {
        $91245019425ebde7$var$displayErrorMessage($91245019425ebde7$var$ERROR_MESSAGES.DEFAULT);
        return;
    }
    const result = await $91245019425ebde7$var$postToCart(selectedVariants, $91245019425ebde7$var$elements.addBundleButton);
    if (result.success) {
        try {
            const delta = selectedVariants.reduce((sum, v)=>sum + (v.quantity || 0), 0);
            if (delta > 0) {
                const cartItemsNode = $91245019425ebde7$var$elements.cartItemsEl || document.querySelector("[data-cart-items]");
                if (cartItemsNode) {
                    const current = parseInt(cartItemsNode.dataset.cartItems ?? "0", 10) || 0;
                    cartItemsNode.dataset.cartItems = String(current + delta);
                    $91245019425ebde7$var$updatePriceUI();
                }
            }
        } catch (err) {
            console.warn("Optimistic cart count update failed; falling back to server refresh.", err);
        }
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        const cartLink = document.querySelector('a[aria-controls="cart-drawer"]');
        if (cartLink instanceof HTMLElement) cartLink.click();
    }
}
const $91245019425ebde7$var$debouncedPriceUpdate = (0, $e1fa18a0ea3067b5$export$61fc7d43ac8f84b0)(()=>{
    $91245019425ebde7$var$updatePriceUI();
}, 300);
function $91245019425ebde7$var$ensureQuantityListeners() {
    const input = $91245019425ebde7$var$elements.quantityInput;
    if (!input) return;
    input.removeEventListener("change", $91245019425ebde7$var$debouncedPriceUpdate);
    input.removeEventListener("input", $91245019425ebde7$var$debouncedPriceUpdate);
    input.addEventListener("change", $91245019425ebde7$var$debouncedPriceUpdate);
    input.addEventListener("input", $91245019425ebde7$var$debouncedPriceUpdate);
}
async function $91245019425ebde7$var$handleCartUpdate() {
    const selectorsToUpdate = !$91245019425ebde7$var$isFixBundleContext() ? [
        $91245019425ebde7$var$selectors.dataCartItems,
        ".header__cart-count",
        $91245019425ebde7$var$selectors.productData,
        "product-rerender",
        ".product-info__badge-list",
        ".bundle-item__info"
    ] : [
        $91245019425ebde7$var$selectors.dataCartItems,
        ".header__cart-count",
        $91245019425ebde7$var$selectors.productData,
        "product-rerender",
        ".product-info__badge-list",
        ".bundle-item__info"
    ];
    await (0, $d4f48f8a853fbb3a$export$c5303087167e431c)(selectorsToUpdate);
    $91245019425ebde7$var$cacheElements();
    $91245019425ebde7$var$ensureAddButtonListener();
    $91245019425ebde7$var$debouncedPriceUpdate();
    // Nudge bundle discount UIs (built client-side) to recalc immediately
    document.dispatchEvent(new CustomEvent("bundle:refresh-discount"));
}
async function $91245019425ebde7$var$handleBundleInputChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches("[data-variant-radio-input]")) return;
    document.dispatchEvent(new CustomEvent("variant:change"));
}
function $91245019425ebde7$var$bindEventListeners() {
    $91245019425ebde7$var$ensureAddButtonListener();
    if ($91245019425ebde7$var$elements.quantityInput) $91245019425ebde7$var$ensureQuantityListeners();
    const debouncedCartUpdate = (0, $e1fa18a0ea3067b5$export$61fc7d43ac8f84b0)($91245019425ebde7$var$handleCartUpdate, 120);
    document.addEventListener("cart:change", debouncedCartUpdate);
    document.addEventListener("cart:refresh", debouncedCartUpdate);
    document.addEventListener("cart:change", $91245019425ebde7$var$invalidateDiscountRulesCache);
    document.addEventListener("cart:refresh", $91245019425ebde7$var$invalidateDiscountRulesCache);
    document.addEventListener("variant:change", $91245019425ebde7$var$invalidateDiscountRulesCache);
    document.addEventListener("shopify:section:load", $91245019425ebde7$var$invalidateDiscountRulesCache);
    const debouncedRefreshUI = (0, $e1fa18a0ea3067b5$export$61fc7d43ac8f84b0)(()=>{
        $91245019425ebde7$var$cacheElements();
        $91245019425ebde7$var$ensureQuantityListeners();
        $91245019425ebde7$var$ensureAddButtonListener();
        $91245019425ebde7$var$debouncedPriceUpdate();
    }, 150);
    document.addEventListener("shopify:section:load", debouncedRefreshUI);
    // Delegate change events for dynamically inserted bundle inputs
    document.addEventListener("change", (event)=>{
        const t = event.target;
        if (!(t instanceof HTMLInputElement)) return;
        if (!t.matches("[data-variant-radio-input]")) return;
        $91245019425ebde7$var$handleBundleInputChange(event);
    });
    document.addEventListener("variant:change", debouncedRefreshUI);
}
function $91245019425ebde7$var$main() {
    $91245019425ebde7$var$cacheElements();
    $91245019425ebde7$var$bindEventListeners();
    $91245019425ebde7$var$updatePriceUI();
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $91245019425ebde7$var$main);
else $91245019425ebde7$var$main();



document.addEventListener("cart:change", async ()=>{
    await (0, $d4f48f8a853fbb3a$export$c5303087167e431c)([
        "product-card"
    ]);
});



document.addEventListener("cart:change", async ()=>{
    await (0, $d4f48f8a853fbb3a$export$c5303087167e431c)([
        ".discount-block__wrapper"
    ]);
});


const $e9a1f8f834930991$var$progressChangedCallback = ()=>{
    const progressBars = document.querySelectorAll("progress-bar.progress-bar");
    progressBars.forEach((progressBar)=>{
        const max = progressBar.getAttribute("aria-valuemax");
        const now = progressBar.getAttribute("aria-valuenow");
        if (!max || !now) return;
        if (Number(now) >= Number(max)) progressBar.setAttribute("data-progress-complete", "true");
        else progressBar.removeAttribute("data-progress-complete");
    });
};
const $e9a1f8f834930991$var$observeProgressBarChanges = ()=>{
    const body = document.body;
    if (!body || body.hasAttribute("data-progress-observer-bound")) return;
    const observer = new MutationObserver(()=>{
        const bars = document.querySelectorAll("progress-bar.progress-bar");
        if (bars.length) $e9a1f8f834930991$var$progressChangedCallback();
    });
    observer.observe(body, {
        childList: true,
        subtree: true
    });
    body.setAttribute("data-progress-observer-bound", "true");
};
document.addEventListener("DOMContentLoaded", ()=>{
    $e9a1f8f834930991$var$progressChangedCallback();
    $e9a1f8f834930991$var$observeProgressBarChanges();
    document.addEventListener("cart:change", ()=>{
        setTimeout($e9a1f8f834930991$var$progressChangedCallback, 500);
    });
});


function $1637d1304a8f1376$var$showQuantityConfirmModal() {
    return new Promise((resolve)=>{
        const modal = document.querySelector("[data-discount-warning-banner]");
        const overlay = document.querySelector("[data-discount-warning-banner-overlay]");
        if (!(modal instanceof HTMLElement)) return resolve(true);
        const yesBtn = modal.querySelector("[data-confirm-yes]");
        const noBtn = modal.querySelector("[data-confirm-no]");
        function cleanup() {
            modal.classList.remove("discount-warning__visible");
            if (overlay instanceof HTMLElement) overlay.classList.remove("discount-warning__overlay-is-visible");
            yesBtn?.removeEventListener("click", onYes);
            noBtn?.removeEventListener("click", onNo);
        }
        function onYes() {
            cleanup();
            resolve(true);
        }
        function onNo() {
            cleanup();
            resolve(false);
        }
        modal.classList.add("discount-warning__visible");
        if (overlay instanceof HTMLElement) overlay.classList.add("discount-warning__overlay-is-visible");
        yesBtn?.addEventListener("click", onYes, {
            once: true
        });
        noBtn?.addEventListener("click", onNo, {
            once: true
        });
    });
}
function $1637d1304a8f1376$var$bindQuantityTrackingListeners() {
    const root = document.body || document.documentElement;
    if (!root || root.hasAttribute("data-quantity-listeners-bound")) return;
    document.addEventListener("focusin", (e)=>{
        if (!(e.target instanceof HTMLInputElement)) return;
        if (e.target.classList.contains("quantity-input")) e.target.dataset.prevValue = e.target.value;
    });
    document.addEventListener("mousedown", (e)=>{
        const target = e.target;
        if (!(target instanceof HTMLElement)) return;
        if (target.classList.contains("quantity-button")) {
            const inputButtons = target.closest(".quantity-input-buttons");
            if (!inputButtons) return;
            const input = inputButtons.querySelector(".quantity-input");
            if (input instanceof HTMLInputElement) input.dataset.prevValue = input.value;
        }
    });
    root.setAttribute("data-quantity-listeners-bound", "true");
}
function $1637d1304a8f1376$var$patchChangeLineItemQuantity() {
    const el = document.querySelector("line-item-quantity");
    if (!el) return;
    const proto = Object.getPrototypeOf(el);
    if (!proto._changeLineItemQuantity || proto._changeLineItemQuantity.__patched) return;
    const originalChange = proto._changeLineItemQuantity;
    proto._changeLineItemQuantity = async function(...args) {
        const input = this.querySelector("input.quantity-input");
        const oldQuantity = args[2] ?? (input ? parseInt(input.defaultValue, 10) : NaN);
        const targetQuantity = args[1];
        if (!isNaN(oldQuantity) && typeof targetQuantity === "number" && targetQuantity < oldQuantity) {
            const confirmed = await $1637d1304a8f1376$var$showQuantityConfirmModal();
            if (!confirmed) {
                if (input) input.value = oldQuantity.toString();
                const decreaseBtn = this.querySelector(".quantity-button.decrease");
                if (decreaseBtn) decreaseBtn.disabled = oldQuantity <= 0;
                return;
            }
        }
        return originalChange.apply(this, args);
    };
    proto._changeLineItemQuantity.__patched = true;
}
function $1637d1304a8f1376$var$rebindQuantityListeners() {
    $1637d1304a8f1376$var$bindQuantityTrackingListeners();
    $1637d1304a8f1376$var$patchChangeLineItemQuantity();
}
document.addEventListener("DOMContentLoaded", $1637d1304a8f1376$var$rebindQuantityListeners);
document.addEventListener("shopify:section:load", $1637d1304a8f1376$var$rebindQuantityListeners);
document.addEventListener("cart:change", $1637d1304a8f1376$var$rebindQuantityListeners);


const $efcb1ece300604d5$export$687956aaad0c3590 = "/api/2025-07/graphql.json";
const $efcb1ece300604d5$export$53303c02b08f34c8 = 15000;
const $efcb1ece300604d5$export$94df19ecb868bc1a = (obj, key)=>typeof obj === "object" && obj !== null && key in obj;
function $efcb1ece300604d5$export$6ba840931da50680(value) {
    return typeof value === "object" && value !== null;
}
function $efcb1ece300604d5$export$ce46fa4165cdec40(value) {
    if (!$efcb1ece300604d5$export$6ba840931da50680(value)) return false;
    return typeof value.id === "string" && typeof value.availableForSale === "boolean" && typeof value.title === "string";
}
function $efcb1ece300604d5$export$25ed5a80fda8f5fe(items) {
    const seenHandles = new Set();
    return items.filter((item)=>seenHandles.has(item.handle) ? false : (seenHandles.add(item.handle), true));
}
function $efcb1ece300604d5$export$84e6ad161395495c(items, currentHandle) {
    return [
        ...items
    ].sort((a, b)=>a.handle === currentHandle ? -1 : b.handle === currentHandle ? 1 : a.title.localeCompare(b.title));
}
async function $efcb1ece300604d5$export$5ba50263d70e92e8(groupTag) {
    const token = window.STOREFRONT_TOKEN;
    if (!token) return [];
    const query = `#graphql
    query ProductsByTag($query: String!) {
      products(first: 100, query: $query) {
        nodes {
          handle
          title
          metafield(namespace: "custom", key: "fragrance") { value }
        }
      }
    }
  `;
    const controller = new AbortController();
    const timeout = setTimeout(()=>controller.abort(), $efcb1ece300604d5$export$53303c02b08f34c8);
    try {
        const res = await fetch($efcb1ece300604d5$export$687956aaad0c3590, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": token
            },
            body: JSON.stringify({
                query: query,
                variables: {
                    query: `tag:${JSON.stringify(groupTag)}`
                }
            }),
            signal: controller.signal
        });
        clearTimeout(timeout);
        if (!res.ok) return [];
        const json = await res.json();
        if (!$efcb1ece300604d5$export$94df19ecb868bc1a(json, "data")) return [];
        const data = json.data;
        if (!$efcb1ece300604d5$export$94df19ecb868bc1a(data, "products")) return [];
        const products = data.products;
        if (!$efcb1ece300604d5$export$94df19ecb868bc1a(products, "nodes") || !Array.isArray(products.nodes)) return [];
        const nodes = products.nodes;
        return nodes.filter((n)=>$efcb1ece300604d5$export$6ba840931da50680(n) && typeof n.handle === "string" && typeof n.title === "string" && $efcb1ece300604d5$export$94df19ecb868bc1a(n, "metafield"));
    } catch  {
        clearTimeout(timeout);
        return [];
    }
}
function $efcb1ece300604d5$export$67dcaf721b78a41d(value) {
    if (!$efcb1ece300604d5$export$6ba840931da50680(value)) return false;
    if (typeof value.handle !== "string" || typeof value.title !== "string") return false;
    if (!$efcb1ece300604d5$export$94df19ecb868bc1a(value, "variants")) return false;
    const variantsObj = value.variants;
    if (!$efcb1ece300604d5$export$6ba840931da50680(variantsObj) || !$efcb1ece300604d5$export$94df19ecb868bc1a(variantsObj, "nodes") || !Array.isArray(variantsObj.nodes)) return false;
    return variantsObj.nodes.every($efcb1ece300604d5$export$ce46fa4165cdec40);
}
async function $efcb1ece300604d5$export$b6a58cd5557a2ae6(groupTag) {
    const token = window.STOREFRONT_TOKEN;
    if (!token) return [];
    const query = `#graphql
    query ProductsByTag($query: String!) {
      products(first: 100, query: $query) {
        nodes {
          handle
          title
          featuredImage { url }
          metafield(namespace: "custom", key: "fragrance") { value }
          variants(first: 50) {
            nodes {
              id
              availableForSale
              title
              image { url }
              price { amount }
              priceV2 { amount }
              compareAtPrice { amount }
            }
          }
        }
      }
    }
  `;
    const controller = new AbortController();
    const timeout = setTimeout(()=>controller.abort(), $efcb1ece300604d5$export$53303c02b08f34c8);
    try {
        const res = await fetch($efcb1ece300604d5$export$687956aaad0c3590, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": token
            },
            body: JSON.stringify({
                query: query,
                variables: {
                    query: `tag:${JSON.stringify(groupTag)}`
                }
            }),
            signal: controller.signal
        });
        clearTimeout(timeout);
        if (!res.ok) return [];
        const json = await res.json();
        if (!$efcb1ece300604d5$export$94df19ecb868bc1a(json, "data")) return [];
        const data = json.data;
        if (!$efcb1ece300604d5$export$94df19ecb868bc1a(data, "products")) return [];
        const products = data.products;
        if (!$efcb1ece300604d5$export$94df19ecb868bc1a(products, "nodes") || !Array.isArray(products.nodes)) return [];
        const nodesUnknown = products.nodes;
        return nodesUnknown.filter($efcb1ece300604d5$export$67dcaf721b78a41d);
    } catch  {
        clearTimeout(timeout);
        return [];
    }
}
function $efcb1ece300604d5$export$51c39835b8b3db23(product) {
    const variants = product.variants?.nodes ?? [];
    const available = variants.find((variant)=>variant.availableForSale) || variants[0];
    return available || null;
}
function $efcb1ece300604d5$export$4bf5b1841f02f4a7(product) {
    const raw = product.metafield?.value;
    return typeof raw === "string" && raw.trim() ? raw.trim() : product.title;
}
function $efcb1ece300604d5$export$b7e427d972e6a4c9(amount) {
    if (!amount) return 0;
    const val = parseFloat(amount);
    if (Number.isNaN(val)) return 0;
    return Math.round(val * 100);
}


function $d99216e9576ad434$var$renderFragrances(container, products, currentHandle) {
    container.innerHTML = "";
    const fragment = document.createDocumentFragment();
    for (const product of products){
        const fragrance = product.metafield?.value?.trim();
        const label = fragrance && fragrance.length > 0 ? fragrance : product.title;
        const link = document.createElement("a");
        link.className = "block-swatch";
        link.textContent = label;
        if (product.handle === currentHandle) {
            link.setAttribute("aria-current", "page");
            link.classList.add("is-selected");
        } else {
            const root = window.Shopify?.routes?.root ?? "/";
            link.href = `${root}products/${product.handle}`;
        }
        fragment.appendChild(link);
    }
    container.appendChild(fragment);
}
async function $d99216e9576ad434$var$initProductGroups(groupContainer) {
    const groupTag = groupContainer.getAttribute("data-group-tag");
    const currentHandle = groupContainer.getAttribute("data-current-handle") || "";
    if (!groupTag) return;
    const valuesRow = groupContainer.querySelector('[data-row="fragrance"]');
    if (!valuesRow) return;
    if (valuesRow.childElementCount > 0 || valuesRow.hasAttribute("data-preloaded")) {
        groupContainer.classList.remove("is-loading");
        return;
    }
    try {
        const products = await (0, $efcb1ece300604d5$export$5ba50263d70e92e8)(groupTag);
        const uniqueProducts = (0, $efcb1ece300604d5$export$25ed5a80fda8f5fe)(products);
        const sorted = (0, $efcb1ece300604d5$export$84e6ad161395495c)(uniqueProducts, currentHandle);
        $d99216e9576ad434$var$renderFragrances(valuesRow, sorted, currentHandle);
    } finally{
        groupContainer.classList.remove("is-loading");
    }
}
function $d99216e9576ad434$var$mountProductGroups(root = document) {
    const containers = root.querySelectorAll("[data-color-groups]");
    containers.forEach((container)=>void $d99216e9576ad434$var$initProductGroups(container));
}
const $d99216e9576ad434$var$init = ()=>$d99216e9576ad434$var$mountProductGroups();
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", $d99216e9576ad434$var$init) : $d99216e9576ad434$var$init();
document.addEventListener("shopify:section:load", ()=>$d99216e9576ad434$var$mountProductGroups());





function $a44a7f49586bb795$var$readApplicableDiscount() {
    const discountNode = document.querySelector("[data-product-data] [data-applicable-discount]");
    if (!(discountNode instanceof HTMLElement)) return 0;
    const raw = discountNode.getAttribute("data-applicable-discount") || discountNode.dataset.applicableDiscount || "0";
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}
function $a44a7f49586bb795$var$refreshBundleDiscountUI(root = document) {
    const discountPercent = $a44a7f49586bb795$var$readApplicableDiscount();
    const discountLabel = (0, $661ba832864544bd$export$d73ee8ef04f5226a)("product.discount.offer", "Fresh Offer");
    const discountBadges = root.querySelectorAll(".bundle-items [data-discount-badge]");
    discountBadges.forEach((badge)=>{
        const badgeText = badge.querySelector("[data-discount-text]");
        if (discountPercent > 0 && badgeText) {
            badgeText.textContent = `${discountLabel} ${discountPercent} %`;
            badge.removeAttribute("hidden");
        } else badge.setAttribute("hidden", "");
    });
    const itemCards = root.querySelectorAll(".bundle-items [data-bundle-item], .bundle-items .bundle-item");
    itemCards.forEach((item)=>{
        const baseCentsRaw = item.getAttribute("data-base-price-cents") || "";
        const baseCents = parseInt(baseCentsRaw, 10);
        const comparePriceEl = item.querySelector("[data-compare-price]");
        const salePriceEl = item.querySelector("[data-sale-price]");
        if (!salePriceEl || !Number.isFinite(baseCents)) return;
        const formatMoneyMajor = (val)=>(0, $19bf1ee578786977$export$a17b3c2052469c69)(val / 100);
        if (discountPercent > 0) {
            const itemDiscount = Math.floor(baseCents * (discountPercent / 100));
            const discounted = Math.max(baseCents - itemDiscount, 0);
            if (comparePriceEl) {
                comparePriceEl.textContent = formatMoneyMajor(baseCents);
                comparePriceEl.removeAttribute("hidden");
            }
            salePriceEl.textContent = formatMoneyMajor(discounted);
            salePriceEl.classList.add("text-on-sale");
            salePriceEl.classList.remove("text-subdued");
        } else {
            if (comparePriceEl) comparePriceEl.setAttribute("hidden", "");
            salePriceEl.textContent = formatMoneyMajor(baseCents);
            salePriceEl.classList.remove("text-on-sale");
            salePriceEl.classList.add("text-subdued");
        }
    });
}
function $a44a7f49586bb795$var$createBundleGroupElement(products, currentHandle, inputName, quantity) {
    const groupEl = document.createElement("div");
    groupEl.className = "bundle-items";
    const uniqueProducts = (0, $efcb1ece300604d5$export$25ed5a80fda8f5fe)(products);
    const sorted = (0, $efcb1ece300604d5$export$84e6ad161395495c)(uniqueProducts, currentHandle);
    const firstAvailable = sorted.find((product)=>(0, $efcb1ece300604d5$export$51c39835b8b3db23)(product)?.availableForSale);
    const activeVariantId = (0, $efcb1ece300604d5$export$51c39835b8b3db23)(firstAvailable || sorted[0])?.id || null;
    const numericId = (globalId)=>{
        if (!globalId) return null;
        const match = globalId.match(/(\d+)$/);
        return match ? match[1] : null;
    };
    const compareAtAmount = (value)=>{
        if (!(0, $efcb1ece300604d5$export$6ba840931da50680)(value)) return null;
        const compareAt = Reflect.get(value, "compareAtPrice");
        if (!(0, $efcb1ece300604d5$export$6ba840931da50680)(compareAt)) return null;
        const amount = Reflect.get(compareAt, "amount");
        return typeof amount === "string" ? amount : null;
    };
    const discountPercent = $a44a7f49586bb795$var$readApplicableDiscount();
    const discountLabel = (0, $661ba832864544bd$export$d73ee8ef04f5226a)("product.discount.offer", "Fresh Offer");
    const isSafeHttpUrl = (url)=>/^https?:\/\//.test(url);
    const cloneFromTemplate = (key)=>{
        const templateEl = document.querySelector(`template[data-template="${key}"]`) || document.getElementById(key);
        if (!(templateEl instanceof HTMLTemplateElement)) return null;
        const firstTemplateChild = templateEl.content.firstElementChild;
        if (!firstTemplateChild) return null;
        const clonedElement = firstTemplateChild.cloneNode(true);
        return clonedElement instanceof Element ? clonedElement : null;
    };
    const bySel = (root, sel)=>root.querySelector(sel);
    let index = 0;
    for (const product of sorted){
        const variant = (0, $efcb1ece300604d5$export$51c39835b8b3db23)(product);
        if (!variant) continue;
        const isActive = activeVariantId ? variant.id === activeVariantId : false;
        const imageUrl = (variant.image?.url || product.featuredImage?.url) ?? "";
        const unitPriceCents = (0, $efcb1ece300604d5$export$b7e427d972e6a4c9)(variant.price?.amount || variant.priceV2?.amount || null);
        const qtyEach = Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
        const priceCents = unitPriceCents * qtyEach;
        const unitCompareCents = (0, $efcb1ece300604d5$export$b7e427d972e6a4c9)(compareAtAmount(variant));
        const compareCents = unitCompareCents * qtyEach;
        const hasSale = compareCents > priceCents && compareCents > 0;
        const savingsCents = hasSale ? compareCents - priceCents : 0;
        const savingsPercent = hasSale && compareCents > 0 ? Math.round(savingsCents / compareCents * 100) : 0;
        const settings = window.themeVariables?.settings;
        const showDiscount = settings?.showDiscount !== false;
        const usePercent = settings?.discountMode === "percentage";
        const savingsLabel = usePercent && savingsPercent > 0 ? `${savingsPercent}%` : (0, $19bf1ee578786977$export$a17b3c2052469c69)(savingsCents / 100);
        const showSaleBadge = showDiscount && hasSale && index > 0;
        const itemBase = cloneFromTemplate("tpl-bundle-item");
        if (itemBase && itemBase instanceof HTMLElement) {
            const itemEl = itemBase;
            if (isActive) itemEl.classList.add("is-active");
            itemEl.setAttribute("data-variant-id", numericId(variant.id) ?? "");
            itemEl.setAttribute("data-base-price-cents", String(priceCents));
            const imageEl = bySel(itemEl, "[data-bundle-img]");
            if (imageEl instanceof HTMLImageElement) {
                if (imageUrl && isSafeHttpUrl(imageUrl)) {
                    imageEl.src = imageUrl;
                    imageEl.alt = product.title;
                    imageEl.removeAttribute("hidden");
                } else imageEl.parentElement?.remove();
            }
            const productLinkEl = bySel(itemEl, "[data-bundle-link]");
            const quantityEl = bySel(itemEl, "[data-bundle-quantity]");
            if (productLinkEl instanceof HTMLAnchorElement) {
                const shopifyRoot = window.Shopify?.routes?.root;
                const root = typeof shopifyRoot === "string" && shopifyRoot.length > 0 ? shopifyRoot : "/";
                productLinkEl.href = `${root}products/${encodeURIComponent(product.handle)}`;
                const qty = Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
                productLinkEl.textContent = product.title;
                if (quantityEl instanceof HTMLElement) {
                    if (qty > 0) {
                        quantityEl.textContent = String(qty);
                        quantityEl.removeAttribute("hidden");
                    } else quantityEl.setAttribute("hidden", "");
                }
            }
            const variantTitleEl = bySel(itemEl, "[data-variant-title]");
            if (variantTitleEl instanceof HTMLElement) {
                if (variant.title && variant.title !== "Default Title") {
                    variantTitleEl.textContent = variant.title;
                    variantTitleEl.removeAttribute("hidden");
                }
            }
            const comparePriceEl = bySel(itemEl, "[data-compare-price]");
            const salePriceEl = bySel(itemEl, "[data-sale-price]");
            if (salePriceEl instanceof HTMLElement) {
                if (discountPercent > 0) {
                    const itemDiscount = Math.floor(priceCents * (discountPercent / 100));
                    const discounted = Math.max(priceCents - itemDiscount, 0);
                    if (comparePriceEl instanceof HTMLElement) {
                        comparePriceEl.textContent = (0, $19bf1ee578786977$export$a17b3c2052469c69)(priceCents / 100);
                        comparePriceEl.removeAttribute("hidden");
                    }
                    salePriceEl.textContent = (0, $19bf1ee578786977$export$a17b3c2052469c69)(discounted / 100);
                    salePriceEl.classList.add("text-on-sale");
                    salePriceEl.classList.remove("text-subdued");
                } else {
                    if (comparePriceEl instanceof HTMLElement && hasSale) {
                        comparePriceEl.textContent = (0, $19bf1ee578786977$export$a17b3c2052469c69)(compareCents / 100);
                        comparePriceEl.removeAttribute("hidden");
                    }
                    salePriceEl.textContent = (0, $19bf1ee578786977$export$a17b3c2052469c69)(priceCents / 100);
                    salePriceEl.classList.toggle("text-on-sale", hasSale);
                    salePriceEl.classList.toggle("text-subdued", !hasSale);
                }
            }
            const onSaleBadge = bySel(itemEl, "[data-sale-badge]");
            if (onSaleBadge instanceof HTMLElement) onSaleBadge.setAttribute("hidden", "");
            const discountBadge = bySel(itemEl, "[data-discount-badge]");
            const discountText = bySel(itemEl, "[data-discount-text]");
            if (discountPercent > 0 && discountBadge instanceof HTMLElement && discountText instanceof HTMLElement) {
                discountText.textContent = `${discountLabel} ${discountPercent} %`;
                discountBadge.removeAttribute("hidden");
            }
            groupEl.appendChild(itemEl);
        }
        index += 1;
    }
    const inputsEl = document.createElement("div");
    inputsEl.className = "bundle-item__variant-inputs";
    let checkedAssigned = false;
    for (const product of sorted){
        const variant = (0, $efcb1ece300604d5$export$51c39835b8b3db23)(product);
        if (!variant) continue;
        const priceCents = (0, $efcb1ece300604d5$export$b7e427d972e6a4c9)(variant.price?.amount || variant.priceV2?.amount || null);
        const vidNumeric = numericId(variant.id) ?? "";
        const inputId = `${inputName}_${vidNumeric}`;
        const optionLabel = (0, $efcb1ece300604d5$export$4bf5b1841f02f4a7)(product);
        const disabled = variant.availableForSale ? "" : "disabled";
        const checked = !checkedAssigned && variant.availableForSale || (activeVariantId ? variant.id === activeVariantId : false);
        if (checked) checkedAssigned = true;
        const wrapper = cloneFromTemplate("tpl-bundle-input");
        if (wrapper) {
            const input = bySel(wrapper, "[data-variant-radio-input]");
            const labelEl = bySel(wrapper, "[data-bundle-swatch]");
            if (input instanceof HTMLInputElement && labelEl instanceof HTMLLabelElement) {
                input.id = inputId;
                input.name = inputName;
                input.value = vidNumeric;
                input.dataset.variantPrice = String(priceCents);
                const qtyEach = Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
                input.dataset.variantQty = String(qtyEach);
                if (checked) input.checked = true;
                if (disabled) input.disabled = true;
                labelEl.setAttribute("for", inputId);
                labelEl.textContent = optionLabel;
                labelEl.className = `block-swatch ${variant.availableForSale ? "available" : "unavailable"}`;
                // append only input + label to match existing CSS
                inputsEl.appendChild(input);
                inputsEl.appendChild(labelEl);
            }
        }
    }
    groupEl.appendChild(inputsEl);
    $a44a7f49586bb795$var$refreshBundleDiscountUI(groupEl);
    return groupEl;
}
function $a44a7f49586bb795$var$isDatasetVariant(val) {
    if (!(0, $efcb1ece300604d5$export$6ba840931da50680)(val)) return false;
    return typeof val.id === "string" && typeof val.availableForSale === "boolean" && typeof val.title === "string";
}
function $a44a7f49586bb795$var$isDatasetProduct(val) {
    if (!(0, $efcb1ece300604d5$export$6ba840931da50680)(val)) return false;
    if (typeof val.handle !== "string" || typeof val.title !== "string") return false;
    if (!(0, $efcb1ece300604d5$export$94df19ecb868bc1a)(val, "variants") || !Array.isArray(val.variants)) return false;
    return val.variants.every($a44a7f49586bb795$var$isDatasetVariant);
}
function $a44a7f49586bb795$var$fromDatasetToGroupProducts(products) {
    return products.map((datasetProduct)=>({
            handle: datasetProduct.handle,
            title: datasetProduct.title,
            featuredImage: datasetProduct.featuredImageUrl ? {
                url: datasetProduct.featuredImageUrl
            } : undefined,
            metafield: {
                value: typeof datasetProduct.fragrance === "string" ? datasetProduct.fragrance : null
            },
            variants: {
                nodes: datasetProduct.variants.map((datasetVariant)=>({
                        id: datasetVariant.id,
                        availableForSale: datasetVariant.availableForSale,
                        title: datasetVariant.title,
                        image: datasetVariant.imageUrl ? {
                            url: datasetVariant.imageUrl
                        } : null,
                        price: typeof datasetVariant.priceCents === "number" ? {
                            amount: (datasetVariant.priceCents / 100).toFixed(2)
                        } : null,
                        priceV2: null
                    }))
            }
        }));
}
async function $a44a7f49586bb795$var$initializeBundleGroup(placeholder) {
    const currentHandle = placeholder.getAttribute("data-current-handle") || "";
    const inputName = placeholder.getAttribute("data-input-name") || "bundle_dynamic";
    const json = placeholder.getAttribute("data-products");
    const qtyAttr = placeholder.getAttribute("data-quantity") || "";
    const quantity = (()=>{
        const parsed = parseInt(qtyAttr, 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    })();
    if (json) try {
        const parsedData = JSON.parse(json);
        const items = Array.isArray(parsedData) ? parsedData : [];
        const datasetProducts = items.filter($a44a7f49586bb795$var$isDatasetProduct);
        if (datasetProducts.length > 0) {
            const groupProducts = $a44a7f49586bb795$var$fromDatasetToGroupProducts(datasetProducts);
            const groupEl = $a44a7f49586bb795$var$createBundleGroupElement(groupProducts, currentHandle, inputName, quantity);
            placeholder.replaceWith(groupEl);
            document.dispatchEvent(new CustomEvent("variant:change"));
            return;
        }
    } catch (err) {
        console.warn("bundle-group-by-tag: Failed to parse data-products JSON; falling back to API fetch.", err);
    }
    const groupTag = placeholder.getAttribute("data-group-tag") || "";
    if (groupTag) {
        const products = await (0, $efcb1ece300604d5$export$b6a58cd5557a2ae6)(groupTag);
        if (products && products.length > 0) {
            const groupEl = $a44a7f49586bb795$var$createBundleGroupElement(products, currentHandle, inputName, quantity);
            placeholder.replaceWith(groupEl);
            document.dispatchEvent(new CustomEvent("variant:change"));
        }
    }
}
function $a44a7f49586bb795$var$mountBundleGroups(root = document) {
    const selectors = "[data-bundle-group-products], [data-bundle-group-by-tag]";
    const placeholders = root.querySelectorAll(selectors);
    placeholders.forEach((el)=>void $a44a7f49586bb795$var$initializeBundleGroup(el));
}
const $a44a7f49586bb795$var$init = ()=>$a44a7f49586bb795$var$mountBundleGroups();
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", $a44a7f49586bb795$var$init) : $a44a7f49586bb795$var$init();
document.addEventListener("shopify:section:load", ()=>$a44a7f49586bb795$var$mountBundleGroups());
document.addEventListener("cart:change", ()=>$a44a7f49586bb795$var$refreshBundleDiscountUI());
document.addEventListener("cart:refresh", ()=>$a44a7f49586bb795$var$refreshBundleDiscountUI());
document.addEventListener("variant:change", ()=>$a44a7f49586bb795$var$refreshBundleDiscountUI());
document.addEventListener("bundle:refresh-discount", ()=>$a44a7f49586bb795$var$refreshBundleDiscountUI());


document.querySelectorAll(".tiered-pricing__toggle").forEach((toggle)=>{
    toggle.addEventListener("click", (event)=>{
        const button = event.currentTarget;
        if (!(button instanceof HTMLButtonElement)) return;
        const controls = button.getAttribute("aria-controls");
        if (!controls) return;
        const panel = document.getElementById(controls);
        if (!panel) return;
        const isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!isExpanded));
        panel.classList.toggle("is-open", !isExpanded);
    });
});


const $b3ee8d1793617d74$var$triggerChange = async (inputEl, oldQuantity)=>{
    const el = inputEl.closest("line-item-quantity");
    const host = el instanceof HTMLElement ? el : null;
    const lineKey = inputEl.getAttribute("data-line-key");
    const newQuantity = parseInt(inputEl.value || "", 10);
    const prev = typeof oldQuantity === "number" ? oldQuantity : parseInt(inputEl.dataset.prevValue || inputEl.defaultValue || "", 10);
    if (host && typeof host._changeLineItemQuantity === "function" && lineKey) {
        const result = host._changeLineItemQuantity(lineKey, newQuantity, isNaN(prev) ? undefined : prev);
        if (result instanceof Promise) await result;
    } else {
        inputEl.dispatchEvent(new Event("change", {
            bubbles: true
        }));
        await new Promise((resolve)=>setTimeout(resolve, 250));
    }
};
const $b3ee8d1793617d74$var$parseInteger = (text, defaultValue)=>{
    const source = (text ?? "").trim();
    if (!/^-?\d+$/.test(source)) return defaultValue;
    const parsed = Number(source);
    return Number.isInteger(parsed) ? parsed : defaultValue;
};
const $b3ee8d1793617d74$var$updateDecreaseButton = (input)=>{
    const container = input.closest(".quantity-input-buttons");
    const decreaseBtn = container?.querySelector(".quantity-button.decrease");
    if (!(decreaseBtn instanceof HTMLButtonElement)) return;
    const current = $b3ee8d1793617d74$var$parseInteger(input.value, 1);
    const min = $b3ee8d1793617d74$var$parseInteger(input.min, 1);
    decreaseBtn.disabled = min === 1 ? current <= 0 : current <= min;
};
const $b3ee8d1793617d74$var$quantityChangeHandler = ()=>{
    document.addEventListener("click", async (e)=>{
        const target = e.target;
        if (!(target instanceof Element)) return;
        const button = target.closest(".quantity-button");
        if (!(button instanceof HTMLElement)) return;
        const wrapper = button.closest(".quantity-input-buttons");
        if (!wrapper) return;
        const inputEl = wrapper.querySelector(".quantity-input");
        if (!(inputEl instanceof HTMLInputElement)) return;
        const step = $b3ee8d1793617d74$var$parseInteger(inputEl.step, 1);
        const min = $b3ee8d1793617d74$var$parseInteger(inputEl.min, 1);
        const max = inputEl.max ? $b3ee8d1793617d74$var$parseInteger(inputEl.max, Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY;
        const current = $b3ee8d1793617d74$var$parseInteger(inputEl.value, min);
        const increasing = button.classList.contains("increase");
        let next;
        if (increasing) next = Math.min(current + step, max);
        else next = min === 1 && current <= 1 ? 0 : Math.max(current - step, min);
        if (increasing && current + step > max) {
            const lineItem = button.closest("[data-line-item]");
            const warning = lineItem?.querySelector(".line-item__warning");
            if (warning) {
                warning.classList.add("line-item__visible");
                setTimeout(()=>warning.classList.remove("line-item__visible"), 2000);
            }
            return;
        }
        if (next === current) return;
        const oldQuantity = parseInt(inputEl.dataset.prevValue || inputEl.defaultValue || inputEl.value || "", 10);
        inputEl.value = String(next);
        $b3ee8d1793617d74$var$updateDecreaseButton(inputEl);
        await $b3ee8d1793617d74$var$triggerChange(inputEl, isNaN(oldQuantity) ? undefined : oldQuantity);
    });
};
document.addEventListener("DOMContentLoaded", ()=>{
    $b3ee8d1793617d74$var$quantityChangeHandler();
    document.querySelectorAll(".quantity-input").forEach($b3ee8d1793617d74$var$updateDecreaseButton);
});


function $46eddee14df3b43c$var$updateBundleItemActiveStates() {
    const groups = document.querySelectorAll("[data-bundle-group]");
    groups.forEach((group)=>{
        const items = Array.from(group.querySelectorAll(".bundle-item, [data-bundle-item]"));
        const checkedRadio = group.querySelector("input[type=radio][data-variant-radio-input]:checked");
        if (checkedRadio) {
            const vid = checkedRadio.value;
            items.forEach((item)=>{
                const isActive = item.getAttribute("data-variant-id") === vid;
                item.classList.toggle("is-active", isActive);
            });
            return;
        }
        const labels = Array.from(group.querySelectorAll("[data-dual-label]"));
        let checkedIndex = labels.findIndex((l)=>l.classList.contains("is-active"));
        if (checkedIndex < 0) checkedIndex = labels.findIndex((label)=>{
            const forId = label.getAttribute("for");
            if (!forId) return false;
            const input = document.getElementById(forId);
            return input instanceof HTMLInputElement && input.checked === true;
        });
        if (checkedIndex < 0) checkedIndex = 0;
        labels.forEach((label, index)=>{
            label.classList.toggle("is-active", index === checkedIndex);
        });
        items.forEach((item, index)=>{
            item.classList.toggle("is-active", index === checkedIndex);
        });
    });
}
$46eddee14df3b43c$var$updateBundleItemActiveStates();
document.addEventListener("click", (e)=>{
    if (!(e.target instanceof Element)) return;
    const label = e.target.closest("[data-dual-label]");
    if (!label) return;
    const groupCandidate = label.closest("[data-bundle-group]");
    const group = groupCandidate instanceof HTMLElement ? groupCandidate : null;
    if (group) {
        const labels = Array.from(group.querySelectorAll("[data-dual-label]"));
        const items = Array.from(group.querySelectorAll(".bundle-item, [data-bundle-item]"));
        const variantId = label.getAttribute("data-input2-id");
        let matched = false;
        if (variantId) {
            const targetItem = group.querySelector(`[data-variant-id="${variantId}"]`);
            if (targetItem) {
                items.forEach((it)=>it.classList.remove("is-active"));
                targetItem.classList.add("is-active");
                labels.forEach((l)=>l.classList.remove("is-active"));
                label.classList.add("is-active");
                matched = true;
            }
        }
        if (!matched) {
            const idx = Math.max(0, labels.findIndex((l)=>l === label));
            labels.forEach((l, i)=>l.classList.toggle("is-active", i === idx));
            items.forEach((it, i)=>it.classList.toggle("is-active", i === idx));
        }
    }
});
document.addEventListener("change", (e)=>{
    const target = e.target;
    if (!(target instanceof Element)) return;
    if (target instanceof HTMLInputElement && target.type === "radio") {
        if (target.closest(".variant-picker") || target.hasAttribute("data-variant-radio-input")) {
            $46eddee14df3b43c$var$updateBundleItemActiveStates();
            document.dispatchEvent(new CustomEvent("variant:change"));
        }
    }
});



const $99f4a1c93c465b99$var$SELECTOR_PRODUCT_ROOT = "[data-product-info]";
const $99f4a1c93c465b99$var$SELECTOR_PRICE_CONTAINER = ".product-info__block-item[data-block-type='price'] .product-info__price";
const $99f4a1c93c465b99$var$SELECTOR_AFTERPAY_PLACEMENT = "square-placement";
const $99f4a1c93c465b99$var$getCurrentPriceCents = (productRoot)=>{
    const priceContainer = productRoot.querySelector($99f4a1c93c465b99$var$SELECTOR_PRICE_CONTAINER);
    if (!priceContainer) return null;
    const saleEl = priceContainer.querySelector("[data-price-sale], .text-on-sale");
    if (saleEl) {
        const cents = (0, $19bf1ee578786977$export$598e5ba180969af0)(saleEl.textContent || "");
        if (cents !== null) return cents;
        return null;
    }
    const regularAttrEl = priceContainer.querySelector("[data-price-regular]");
    if (regularAttrEl) {
        const centsFromText = (0, $19bf1ee578786977$export$598e5ba180969af0)(regularAttrEl.textContent || "");
        if (centsFromText !== null) return centsFromText;
        const dataRegular = regularAttrEl.dataset.priceRegular;
        if (dataRegular) {
            const cents = parseInt(dataRegular, 10);
            if (Number.isFinite(cents)) return Math.max(0, cents);
        }
    }
    return null;
};
const $99f4a1c93c465b99$var$updateAfterpayForProduct = (productRoot)=>{
    const placements = productRoot.querySelectorAll($99f4a1c93c465b99$var$SELECTOR_AFTERPAY_PLACEMENT);
    if (placements.length === 0) return;
    const cents = $99f4a1c93c465b99$var$getCurrentPriceCents(productRoot);
    if (cents === null) return;
    const amount = (0, $19bf1ee578786977$export$7ee1718a1d856601)(cents);
    placements.forEach((placement)=>{
        if (placement.getAttribute("data-amount") === amount) return;
        placement.setAttribute("data-amount", amount);
        placement.dispatchEvent(new Event("change"));
    });
};
const $99f4a1c93c465b99$var$boundRoots = new WeakSet();
const $99f4a1c93c465b99$var$observeProductPrice = (productRoot)=>{
    if ($99f4a1c93c465b99$var$boundRoots.has(productRoot)) return;
    const priceContainer = productRoot.querySelector($99f4a1c93c465b99$var$SELECTOR_PRICE_CONTAINER);
    if (!priceContainer) return;
    $99f4a1c93c465b99$var$updateAfterpayForProduct(productRoot);
    let animationFrameId = 0;
    const observer = new MutationObserver(()=>{
        if (animationFrameId) cancelAnimationFrame(animationFrameId);
        animationFrameId = requestAnimationFrame(()=>{
            animationFrameId = 0;
            $99f4a1c93c465b99$var$updateAfterpayForProduct(productRoot);
        });
    });
    observer.observe(priceContainer, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    });
    $99f4a1c93c465b99$var$boundRoots.add(productRoot);
};
const $99f4a1c93c465b99$var$bindAfterpay = ()=>{
    document.querySelectorAll($99f4a1c93c465b99$var$SELECTOR_PRODUCT_ROOT).forEach($99f4a1c93c465b99$var$observeProductPrice);
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $99f4a1c93c465b99$var$bindAfterpay);
else $99f4a1c93c465b99$var$bindAfterpay();
document.addEventListener("shopify:section:load", $99f4a1c93c465b99$var$bindAfterpay);


const $4db029485f2a0d9f$var$initOverwriteBars = ()=>{
    document.querySelectorAll("[data-overwrite-section-id]").forEach((overwriteSection)=>{
        const sectionId = overwriteSection.dataset.overwriteSectionId;
        if (!sectionId) return;
        const stickyEnabled = overwriteSection.dataset.overwriteIsSticky === "true";
        const barElement = document.getElementById(`announcement-bar-${sectionId}`);
        if (!barElement) return;
        const updateHeightAndSticky = (visible)=>{
            if (stickyEnabled && visible) {
                const height = Math.round(barElement.clientHeight) + "px";
                document.documentElement.style.setProperty("--announcement-bar-height", height);
                document.documentElement.style.setProperty("--sticky-announcement-bar-enabled", "1");
            } else {
                document.documentElement.style.setProperty("--announcement-bar-height", "0px");
                document.documentElement.style.setProperty("--sticky-announcement-bar-enabled", "0");
            }
        };
        updateHeightAndSticky(barElement.getBoundingClientRect().bottom > 0);
        const intersectionObserver = new IntersectionObserver(([entry])=>{
            updateHeightAndSticky(entry.intersectionRatio > 0);
        }, {
            threshold: [
                0
            ]
        });
        intersectionObserver.observe(barElement);
        const sectionElement = barElement.closest(".shopify-section");
        if (sectionElement) {
            const onUnload = ()=>{
                intersectionObserver.disconnect();
                sectionElement.removeEventListener("shopify:section:unload", onUnload);
            };
            sectionElement.addEventListener("shopify:section:unload", onUnload);
        }
        window.addEventListener("beforeunload", ()=>intersectionObserver.disconnect());
    });
};
document.addEventListener("DOMContentLoaded", $4db029485f2a0d9f$var$initOverwriteBars);



const $82c492b57db7dd4c$var$waitForKiteAppDataAndUpdate = ()=>{
    const timeout = 30000;
    const interval = 500;
    const startTime = Date.now();
    const checkInterval = setInterval(()=>{
        if (window.kite_app_data) {
            clearInterval(checkInterval);
            (0, $d4f48f8a853fbb3a$export$c5303087167e431c)([
                ".cart-drawer__line-items",
                ".cart-drawer__footer"
            ]);
        } else if (Date.now() - startTime >= timeout) clearInterval(checkInterval);
    }, interval);
};
window.addEventListener("DOMContentLoaded", ()=>{
    $82c492b57db7dd4c$var$waitForKiteAppDataAndUpdate();
});



})();
//# sourceMappingURL=global.js.map
